/* eslint-disable max-len */

import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'wouter';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors, Float, Menu } from '../../../ui';
import { BetterDropButton, DropButton } from '../../../ui/DropButton';
import { Tip } from '../../../ui/Tip';
import { useResolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { Popper, PopperButtonProps } from '../../canvas/ui/Popper';
import { ShowIfHasPermission } from '../../common/PermissionElements';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { accountInvitePopup } from '../../management/AccountInvitePopup';
import { PopupManager } from '../../popups/PopupManager';
import { AccountModel } from '../AccountModel';

// 1C50B7
const Frame = styled.div<{ clickable?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .75rem .75rem .625rem 1rem;
    font-weight: 450;
    user-select: none; 
    background: rgba(0,0,0,0.2);
    border-radius: 1rem 1rem 0 0;

    /* ${BetterDropButton} {
        color: ${Colors.hover};
        &:hover {
            color: ${Colors.primaryText};
        }
    } */
`;

const Name = styled.div`
    margin-right: .25em;
    font-size: 1.0625em;
    font-weight: 450;
    letter-spacing: -.025rem;
`;

const InvertedDropButton = styled(DropButton)`

    &:hover {
        color: ${Colors.primaryText};
    }
    ${p => p.active && css`
        color: ${Colors.primaryText} !important;
    `}
    ${p => p.disabled && css`
        color: white;
        pointer-events: none;
        opacity: .9;
        filter: none;
    `}
`;

const AccountButton = ({ active, onClick }: PopperButtonProps) => {
    const account = useObserver(useResolve(AccountModel));
    const profile = useObserver(useResolve(ProfileModel));
    const disabled = profile.accounts.length <= 1;
    return <Flexer>
        <InvertedDropButton disabled={disabled} active={active} rounding="1" padding=".375" overflow=".25" onClick={onClick}>
            <Name>{account.label}</Name>
            {!disabled && <Icon size="1" src="deqo://icons/hero/chevron-up" />}
        </InvertedDropButton>
    </Flexer>;
};

const AccountMenu = () => {

    const account = useObserver(useResolve(AccountModel));
    const profile = useObserver(useResolve(ProfileModel));

    return <Float shadow="lg" inline>
        <Flexer minWidth="14">
            <Menu>
                <Menu.Section first title="Your Teams">
                    {profile.accounts.map(x =>
                        <a key={x.id} href={`/${x.id}`}>
                            <Menu.Item>
                                <Menu.ItemText>{x.label}</Menu.ItemText>
                                {x.id === account.id && <Menu.Badge color={Colors.positive}>Active</Menu.Badge>}
                            </Menu.Item>
                        </a>
                    )}
                </Menu.Section>
            </Menu>
        </Flexer>
    </Float>;
};

const AccountShortcuts = () => {

    const popups = useResolve(PopupManager);
    const onInviteMembers = () => void (popups.invoke(accountInvitePopup()));

    return <Flexer flex="row" gap=".25">
        <ShowIfHasPermission requires="da:write">
            <Tip text="Invite People" position="top" invert>
                <InvertedDropButton rounding="1" padding=".375" overflow=".25" onClick={onInviteMembers}>
                    <Icon size="1.5" src="deqo://icons/hero/user-add" />
                </InvertedDropButton>
            </Tip>
        </ShowIfHasPermission>
        <ShowIfHasPermission requires="ac_team:read">
            <Link to="~/manage">
                <Tip text="Team Settings" position="top" invert>
                    <InvertedDropButton rounding="1" padding=".375" overflow=".25">
                        <Icon size="1.5" src="deqo://icons/sln/01-interface-essential/settings-slider" />
                    </InvertedDropButton>
                </Tip>
            </Link>
        </ShowIfHasPermission>
    </Flexer>;
};

export const AccountSlice = () =>
    <Frame data-tour="nav-admin">
        <Popper button={AccountButton} content={AccountMenu} placement="bottom-end" inner={{ direction: 'up', offset: '.5' }} />
        <AccountShortcuts />
    </Frame>;
